<app-inventory-template [inventoryOptions]="{
    items_load_endpoint: 'load_inventory',
    items_search_enabled: true,
    items_sort_enabled: true,
    items_pure_filter_enabled: false,
    typography_action_button: 'Join Jackpot',
    typography_title: 'Join Jackpot',
    }"
  [requirementsOptions]="{
        requirements_title: 'Join Jackpot',
        requirements_accent_word: 'bet',
        requirements_options_min_value: 0.3,
        requirements_options_max_value: 10000,
        requirements_options_min_items: 1,
        requirements_options_max_items: 20,
    }"
  [inventorySkinsListConfig]="{ mobile: { skin_min_width: '150px' } }"
  [(selectedSkins)]="selectedSkins"
  [balanceType]="'skins'"
  (action)="joinJackpot()"
 />
